import styled from "@emotion/styled";
import { Box, Button, Grid, Stack, Typography, useTheme } from "@mui/material";
import AppBarCustom from "../../component/AppBar";
import TextFieldCustom from "../../component/textFieldCustom";
import React from "react";
import SelectCustom from "../../component/selectCustom";
import { MapsForm } from "../../component/MapsForm";

import Api from "../../api/RestApi.json";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { SendRounded } from "@mui/icons-material";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),

  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));
export default function PotensiForm(params) {
  const theme = useTheme();
  const goTo = useNavigate();
  const { state } = useLocation();
  const { data } = state;

  const [id, setId] = React.useState(data.id || "");
  const [nama, setNama] = React.useState(data.nama || "");
  const [kategori, setKategori] = React.useState(data.kategori || "");
  const [alamat, setAlamat] = React.useState(data.alamat || "");
  const [kecamatan, setKecamatan] = React.useState(data.kecamatan || "");
  const [kelurahan, setKelurahan] = React.useState(data.kelurahan || "");

  const [telepon, setTelepon] = React.useState(data.telepon || "");
  const [email, setEmail] = React.useState(data.email || "");
  const [website, setWebsite] = React.useState(data.website || "");
  const [deskripsi, setDeskripsi] = React.useState(data.deskripsi || "");

  const [luas, setLuas] = React.useState(data.luas || 0);
  const [produksi, setProduksi] = React.useState(data.produksi || 0);
  const [nilai, setNilai] = React.useState(data.nilai || 0);

  const [latitude, setLatitude] = React.useState(data.latitude || 0.0);
  const [longitude, setLongitude] = React.useState(data.longitude || 0.0);

  const storePost = async (event) => {
    event.preventDefault();
    const data = {
      id,
      nama,
      kategori,
      alamat,
      kecamatan,
      kelurahan,
      telepon,
      email,
      website,
      deskripsi,
      luas,
      produksi,
      nilai,
      latitude,
      longitude,
    };

    try {
      var response = "";
      if (data.id == "") {
        response = await axios.post(Api.potensi, data);
      } else if (data.id !== "") {
        response = await axios.put(Api.potensi + "/" + data.id, data);
      }
      // console.log(response);
      goTo("/potensi");
      goTo(0);
    } catch (error) {
      // console.log(error.response.data);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        padding: 0,
        bgcolor: "#E1E1E1",
      }}
    >
      <AppBarCustom selected="Potensi" />
      {/* <Toolbar sx={{ padding: 10 }} /> */}

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader theme={theme} />
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", marginBottom: 2 }}
            align="left"
          >
            Form Potensi Investasi {data.nama ? " (" + data.nama + ")" : ""}
          </Typography>
          <Button
            variant="contained"
            color="error"
            onClick={(e) => goTo("/potensi")}
          >
            Kembali
          </Button>
        </Stack>

        <Box padding={2} bgcolor={"white"} borderRadius={4}>
          <form onSubmit={storePost}>
            <Grid container spacing={4}>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextFieldCustom
                  title="Nama Titik"
                  name="nama"
                  id="nama"
                  value={nama}
                  onChange={(e) => setNama(e.target.value)}
                  type="text"
                  label="Nama Titik"
                  required={true}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <SelectCustom
                  title="Kategori"
                  name="kategori"
                  id="kategori"
                  value={kategori}
                  onChange={(e) => setKategori(e.target.value)}
                  label="kategori"
                  options={optionsKategori}
                  required={true}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextFieldCustom
                  title="Alamat"
                  name="alamat"
                  id="alamat"
                  value={alamat}
                  onChange={(e) => setAlamat(e.target.value)}
                  type="text"
                  label="Jl...."
                  required={true}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <SelectCustom
                  title="Kecamatan"
                  name="kecamatan"
                  id="kecamatan"
                  value={kecamatan}
                  onChange={(e) => setKecamatan(e.target.value)}
                  label="Musik"
                  options={optionsKecamatan}
                  required={true}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextFieldCustom
                  title="Kelurahan"
                  name="kelurahan"
                  id="kelurahan"
                  value={kelurahan}
                  onChange={(e) => setKelurahan(e.target.value)}
                  type="text"
                  label="Kelurahan"
                  required={true}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 12 }} pt={2}>
                <Typography variant="h4" align="center" fontWeight={"bold"}>
                  Titik Lokasi
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextFieldCustom
                  title="Latitude (Lintang Utara-Selatan)"
                  name="latitude"
                  id="latitude"
                  value={latitude}
                  onChange={(e) => setLatitude(e.target.value)}
                  type="number"
                  label="0.0"
                  required={true}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextFieldCustom
                  title="Longitude (Lintang Timur-Barat)"
                  name="longitude"
                  id="longitude"
                  value={longitude}
                  onChange={(e) => setLongitude(e.target.value)}
                  type="number"
                  label="0.0"
                  required={true}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 12 }}>
                <Box
                  bgcolor={"red"}
                  height={"75vh"}
                  width={{ xs: "100%", md: "75%" }}
                  borderRadius={4}
                  justifySelf={"center"}
                >
                  <MapsForm
                    marker={[latitude, longitude]}
                    latitude={setLatitude}
                    longitude={setLongitude}
                  />
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 12 }}>
                <TextFieldCustom
                  title="Deskripsi"
                  name="deskripsi"
                  id="deskripsi"
                  value={deskripsi}
                  onChange={(e) => setDeskripsi(e.target.value)}
                  type="text"
                  label="Deskripsi lengkap tentang daerah...."
                  required={true}
                  multiline={true}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 12 }} pt={2}>
                <Typography variant="h4" align="center" fontWeight={"bold"}>
                  Detail Lokasi
                </Typography>
              </Grid>
              {/* <Grid size={{ xs: 12, md: 4 }}>
                <TextFieldCustom
                  title="Luas (Hektar)"
                  name="luas"
                  id="luas"
                  value={luas}
                  onChange={(e) => setLuas(e.target.value)}
                  type="number"
                  label="0"
                  required={false}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <TextFieldCustom
                  title="Produksi (per Tahun)"
                  name="produksi"
                  id="produksi"
                  value={produksi}
                  onChange={(e) => setProduksi(e.target.value)}
                  type="number"
                  label="0"
                  required={false}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <TextFieldCustom
                  title="Nilai (Rupiah)"
                  name="nilai"
                  id="nilai"
                  value={nilai}
                  onChange={(e) => setNilai(e.target.value)}
                  type="number"
                  label="0"
                  required={false}
                />
              </Grid> */}
              <Grid size={{ xs: 12, md: 12 }} pt={2}>
                <Typography variant="h4" align="center" fontWeight={"bold"}>
                  Kontak
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <TextFieldCustom
                  title="Nomor Telepon"
                  name="telepon"
                  id="telepon"
                  value={telepon}
                  onChange={(e) => setTelepon(e.target.value)}
                  type="tel"
                  label="+621234567890"
                  required={false}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <TextFieldCustom
                  title="Email"
                  name="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  label="user@gmail.com"
                  required={false}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <TextFieldCustom
                  title="Website"
                  name="website"
                  id="website"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                  type="url"
                  label="https://www.example.com"
                  required={false}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 12 }}>
                <Box justifySelf={"center"}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="success"
                    size="large"
                    startIcon={<SendRounded />}
                  >
                    Kirim
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Box>
    </Box>
  );
}

const optionsKategori = [
  { value: "Pertanian", label: "Pertanian" },
  { value: "Perkebunan", label: "Perkebunan" },
  { value: "Peternakan", label: "Peternakan" },
  { value: "Kehutanan", label: "Kehutanan" },
  { value: "Perikanan", label: "Perikanan" },
  { value: "Pertambangan & Penggalian", label: "Pertambangan & Penggalian" },
  { value: "Jasa Keuangan & Asuransi", label: "Jasa Keuangan & Asuransi" },
  { value: "Perdagangan Besar & Eceran", label: "Perdagangan Besar & Eceran" },
  { value: "Real Estate", label: "Real Estate" },
  { value: "Jasa Pendidikan", label: "Jasa Pendidikan" },
  { value: "Pariwisata", label: "Pariwisata" },
  { value: "Industri Pengolahan", label: "Industri Pengolahan" },
  { value: "Kontruksi", label: "Kontruksi" },
  { value: "Transportasi & Pergudangan", label: "Transportasi & Pergudangan" },
];

const optionsKecamatan = [
  { value: "Basarang", label: "Basarang" },
  { value: "Bataguh", label: "Bataguh" },
  { value: "Dadahup", label: "Dadahup" },
  { value: "Kapuas Barat", label: "Kapuas Barat" },
  { value: "Kapuas Hilir", label: "Kapuas Hilir" },
  { value: "Kapuas Hulu", label: "Kapuas Hulu" },
  { value: "Kapuas Kuala", label: "Kapuas Kuala" },
  { value: "Kapuas Murung", label: "Kapuas Murung" },
  { value: "Kapuas Tengah", label: "Kapuas Tengah" },
  { value: "Kapuas Timur", label: "Kapuas Timur" },
  { value: "Mandau Talawang", label: "Mandau Talawang" },
  { value: "Mantangai", label: "Mantangai" },
  { value: "Pasak Talawang", label: "Pasak Talawang" },
  { value: "Pulau Petak", label: "Pulau Petak" },
  { value: "Selat", label: "Selat" },
  { value: "Tamban Catur", label: "Tamban Catur" },
  { value: "Timpah", label: "Timpah" },
];
